import { Price } from '@app/shared/models/price';
import { CreatedSubscription } from '../service/queries/order-basic.fragment';

export interface OrderItem {
  sku: string;
  orderItemId: string;
  name: string;
  fulfillmentMethod: FulFillmentMethods;
  quantity: number;
  price: Price;
  priceTotal: number;
  fulfillableQuantity: number;
  fulfilledQuantity: number;
  closedQuantity: number;
  refundedQuantity: number;
  selected?: boolean;
  group: {
    name: string;
    description: string;
  };
  createdSubscription?: CreatedSubscription;
}

export interface OrderItemGrouping {
  name: string;
  description: string;
  items: OrderItem[];
}

export enum FulFillmentMethods {
  none = 'None',
  default = 'Default',
  legacySystem = 'LegacySystem',
  storeInternal = 'StoreInternal'
}
